<form [formGroup]="filterForm">
	<div id="delete-simulation-filters" class="row">
		<div class="col-md-3">
			<label>Customers:</label>
			<ng-select
				[items]="filteredCustomers"
				bindLabel="name"
				formControlName="customer"
				[placeholder]="'Select'"
				[clearable]="true"
			>
			</ng-select>
		</div>
		<div class="col-md-3">
			<label>Regions:</label>
			<ng-select
				[items]="filteredRegions"
				bindLabel="name"
				formControlName="region"
				[placeholder]="'Select'"
				[clearable]="true"
			>
			</ng-select>
		</div>
		<div class="col-md-3">
			<label>Projects:</label>
			<ng-select
				[items]="filteredProjects"
				bindLabel="name"
				formControlName="project"
				[placeholder]="'Select'"
				[clearable]="true"
			>
			</ng-select>
		</div>
		<div class="col-md-3">
			<label>Simulations:</label>
			<ng-select
				[items]="filteredSimulations"
				bindLabel="name"
				formControlName="simulation"
				[placeholder]="'Select'"
				[clearable]="true"
			>
			</ng-select>
		</div>
	</div>
	<div class="row reset-row">
				<div class="col-md-2">
			<button type="button" class="btn reset-btn" (click)="resetFilters(['customer','region','project','simulation'], true); setAllFiltered();">
				Reset Filters
			</button>
		</div>
	</div>
</form>